import React from 'react'
import { Link, Typography } from '@mui/material'

import { formatDate, formatMoney } from '../../utils.ts'
import { EMPTY_VALUE } from '../../constants.ts'

export const Amount = ({ value, cur }: { value: number | string | null; cur?: string | null }): React.ReactElement => {
  return <Typography>{value ? formatMoney(value, cur) : EMPTY_VALUE}</Typography>
}

// unix time parses date to users timezone
export const Date = ({ value }: { value: number | null }) => {
  return <Typography>{value ? formatDate(value, true).toString() : EMPTY_VALUE}</Typography>
}

export const Text = ({ value }: { value?: string | null }) => <Typography>{value ?? EMPTY_VALUE}</Typography>

export const BooleanRenderer = ({ value }: { value: boolean }) => <Typography>{value ? 'Да' : 'Нет'}</Typography>

export const LinkRenderer = ({ value }: { value?: string }) =>
  value ? (
    <Link href={value} underline="hover" variant="body1" target="_blank">
      {value}
    </Link>
  ) : (
    <Typography>{EMPTY_VALUE}</Typography>
  )
